import React from 'react';

export const UsersContext = React.createContext({
  updateUser: () => {},
});



// WEBPACK FOOTER //
// ./src/screens/Admin/UsersPanel/UsersContext.jsx